import React, { Component } from 'react';
import './inquire.css';
import {get} from "../../ajax/tools";


class DepotDetails extends Component {

    constructor(props){
        super(props);
        this.state = {
            DepotId:'',
            DepotArr:{},
            DepotAddress:'',
        };
    }

    UNSAFE_componentWillReceiveProps= (nextProps) => {
        const history = nextProps;
        this.setState({
            DepotId:history.DepotId,
        });
    };

    componentDidMount=function() {
        const history = this.props;
        get({url:'agency/train_base_info/'+history.DepotId}).then((res) => {
            if(res.errno === '200'){
                this.setState({
                    DepotArr:res.data[0],
                    DepotAddress:res.data[0].province === res.data[0].city ?
                        res.data[0].city+res.data[0].county+res.data[0].address :
                        res.data[0].province+res.data[0].city+res.data[0].county+res.data[0].address,
                });
            }
        });
        this.setState({
            DepotId:history.DepotId,
        });
    };


    BackButton=()=>{
        this.props.BackButton('BackBtn');
    };



    render() {
        return (
                <div className={'DetailsPackageBox'} style={{minHeight:window.innerHeight-194 > 500 ? window.innerHeight-194 :500,}}>
                    <div className={'DetailsPackageTop'}>
                        <div className={'DetailsBackBox clearfix'} onClick={this.BackButton.bind(this)}>
                            <div className={'DetailsBackIco'}> </div>
                            <div className={'DetailsBackWord'}>返回</div>
                        </div>
                    </div>
                    <div className={'TaAndScDetailsMainBox clearfix'}>
                        <div className={'TaAndScDetailsLeftBox'}>
                            <div className={'TaAndScDetailsCfBox'}>
                                <img alt={''}
                                     src={this.state.DepotArr.image}
                                />
                            </div>
                        </div>
                        <div className={'TaAndScDetailsRightBox'}>
                            <div className={'TaAndScInfoListBox clearfix'}>
                                <div className={'TaAndScInfoTit'}>负责人</div>
                                <div className={'TaAndScInfoCon'}>{this.state.DepotArr.contact}</div>
                            </div>
                            <div className={'TaAndScInfoListBox clearfix'}>
                                <div className={'TaAndScInfoTit'}>所属机构</div>
                                <div className={'TaAndScInfoCon'}>{this.state.DepotArr.org_name}</div>
                            </div>
                            <div className={'TaAndScInfoListBox clearfix'}>
                                <div className={'TaAndScInfoTit'}>基地地址</div>
                                <div className={'TaAndScInfoCon'}>
                                    {this.state.DepotAddress}
                                </div>
                            </div>
                            <div className={'TaAndScInfoListBox clearfix'}>
                                <div className={'TaAndScInfoTit'}>证书到期时间</div>
                                <div className={'TaAndScInfoCon'}>{this.state.DepotArr.expire_time}</div>
                            </div>
                            <div className={'TaAndScInfoListBox clearfix'}>
                                <div className={'TaAndScInfoTit'}>证书编号</div>
                                <div className={'TaAndScInfoCon'}>{this.state.DepotArr.code}</div>
                            </div>
                            <div className={'TaAndScInfoListBox clearfix'}>
                                <div className={'TaAndScInfoTit'}>实训项目</div>
                                <div className={'TaAndScInfoCon'}>{this.state.DepotArr.train_item}</div>
                            </div>
                            <div className={'TaAndScInfoListBox clearfix'}>
                                <div className={'TaAndScInfoTit'}>电子化管理设备数量</div>
                                <div className={'TaAndScInfoCon'}>{this.state.DepotArr.device_num}</div>
                            </div>
                            <div className={'TaAndScInfoListBox clearfix'}>
                                <div className={'TaAndScInfoTit'}>其他模拟设备情况</div>
                                <div className={'TaAndScInfoCon'}>{this.state.DepotArr.other_device}</div>
                            </div>
                        </div>
                        {/*
                            this.state.DepotArr.image !== ''&&
                            <div className={'EquipmentInfo'}>
                                <img alt={''}
                                     src={linshifle}
                                     style={{width:'100%',height:'auto',display:'block',border:'1px solid #030303',}}
                                />
                            </div>
                        */}
                    </div>
                </div>
        );
    }
}


export default DepotDetails;
